import script from "./NonSospendibili.vue?vue&type=script&setup=true&lang=js"
export * from "./NonSospendibili.vue?vue&type=script&setup=true&lang=js"

import "./NonSospendibili.vue?vue&type=style&index=0&id=8b90fed4&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b90fed4"]])

export default __exports__